import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useVessel, Vessel } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<Vessel>
    useData={useVessel}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
